"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _vue = _interopRequireDefault(require("vue"));
var _strftime = _interopRequireDefault(require("strftime"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));
var _MessageCopyFormat = require("@/libs/MessageCopyFormat");
var _RemoveBeforeUpdate = _interopRequireDefault(require("./utils/RemoveBeforeUpdate"));
var _MessageListMessageCompact = _interopRequireDefault(require("./MessageListMessageCompact"));
var _MessageListMessageModern = _interopRequireDefault(require("./MessageListMessageModern"));
var _MessageListMessageInline = _interopRequireDefault(require("./MessageListMessageInline"));
var _MessageListMessageTrafficGroup = _interopRequireDefault(require("./MessageListMessageTrafficGroup"));
var _LoadingAnimation = _interopRequireDefault(require("./LoadingAnimation"));
var _BufferKey = _interopRequireDefault(require("./BufferKey"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
require('@/libs/polyfill/Element.closest');
let log = _Logger.default.namespace('MessageList.vue');

// If we're scrolled up more than this many pixels, don't auto scroll down to the bottom
// of the message list
const BOTTOM_SCROLL_MARGIN = 60;
var _default = exports.default = {
  components: {
    RemoveBeforeUpdate: _RemoveBeforeUpdate.default,
    MessageListMessageModern: _MessageListMessageModern.default,
    MessageListMessageCompact: _MessageListMessageCompact.default,
    MessageListMessageInline: _MessageListMessageInline.default,
    MessageListMessageTrafficGroup: _MessageListMessageTrafficGroup.default,
    LoadingAnimation: _LoadingAnimation.default,
    BufferKey: _BufferKey.default
  },
  props: ['buffer'],
  data() {
    return {
      smooth_scroll: false,
      auto_scroll: true,
      force_smooth_scroll: null,
      chathistoryAvailable: true,
      hover_nick: '',
      message_info_open: null,
      timeToClose: false,
      startClosing: false,
      selectedMessages: Object.create(null)
    };
  },
  computed: {
    thisMl() {
      return this;
    },
    // cached so the hover handler doesn't re-read the setting on every crossing
    showMessageInfoOnHover() {
      return this.$state.setting('buffers.show_message_info_on_hover');
    },
    shouldAutoEmbed() {
      if (this.buffer.isChannel() && this.buffer.setting('inline_link_auto_previews')) {
        return true;
      }
      if (this.buffer.isQuery() && this.buffer.setting('inline_link_auto_previews_query')) {
        return true;
      }
      return false;
    },
    listType() {
      if (this.$state.setting('messageLayout')) {
        log.info('Deprecation Warning: The config option \'messageLayout\' has been moved to buffers.messageLayout');
      }
      return this.buffer.setting('messageLayout') || this.$state.setting('messageLayout');
    },
    useExtraFormatting() {
      // Enables simple markdown formatting
      return this.buffer.setting('extra_formatting');
    },
    shouldShowChathistoryTools() {
      // Only show it if we're connected
      if (this.buffer.getNetwork().state !== 'connected') {
        return false;
      }
      let isCorrectBufferType = this.buffer.isChannel() || this.buffer.isQuery();
      let isSupported = !!this.buffer.getNetwork().ircClient.chathistory.isSupported();
      return isCorrectBufferType && isSupported && (0, _flags.default)(this.buffer).chathistory_available;
    },
    shouldRequestChannelKey() {
      return this.buffer.getNetwork().state === 'connected' && this.buffer.isChannel() && (0, _flags.default)(this.buffer).channel_badkey;
    },
    ourNick() {
      return this.buffer ? this.buffer.getNetwork().nick : '';
    },
    filteredMessagesGroupedDay() {
      // Group messages by day

      const days = [];
      let lastDay = null;
      this.filteredMessages.forEach(message => {
        if (!lastDay || message.day_num !== lastDay) {
          days.push({
            dayNum: message.day_num,
            messages: []
          });
          lastDay = message.day_num;
        }
        days[days.length - 1].messages.push(message);
      });
      return days;
    },
    filteredMessages() {
      return bufferTools.orderedMessages(this.buffer);
    },
    shouldShowJoiningLoader() {
      return this.buffer.isChannel() && this.buffer.enabled && !this.buffer.joined && this.buffer.getNetwork().state === 'connected';
    }
  },
  watch: {
    filteredMessages() {
      // Data has changed and now preparing to update the DOM.
      // Check our scrolling state before the DOM updates so that we know if we're scrolled
      // at the bottom before new messages are added
      this.checkScrollingState();

      // Wait until after the DOM has updated before possibly scrolling down based on the
      // previous check
      this.$nextTick(() => {
        this.maybeScrollToBottom();
      });
    },
    buffer(newBuffer, oldBuffer) {
      if (oldBuffer) {
        oldBuffer.isMessageTrimming = true;
      }
      if (!newBuffer) {
        return;
      }
      this.message_info_open = null;
      if (this.buffer.getNetwork().state === 'connected') {
        (0, _flags.default)(newBuffer).has_opened = true;
      }
      this.auto_scroll = true;
      this.force_smooth_scroll = false;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  },
  mounted() {
    this.addCopyListeners();
    this.$nextTick(() => {
      this.scrollToBottom();
      // this.smooth_scroll = true;
    });
    this.listen(this.$state, 'mediaviewer.opened', () => {
      this.$nextTick(this.maybeScrollToBottom.apply(this));
    });
    this.listen(this.$state, 'messagelist.scrollto', opt => {
      if (opt && opt.id) {
        this.maybeScrollToId(opt.id);
      }
    });
  },
  methods: {
    isTemplateVue(template) {
      const isVue = template instanceof _vue.default;
      if (isVue && !window.kiwi_deprecations_messageTemplate) {
        window.kiwi_deprecations_messageTemplate = true;
        // eslint-disable-next-line no-console
        console.warn('deprecated message.template or message.bodyTemplate, please use `message.template = kiwi.Vue.extend(component object)`');
      }
      return isVue;
    },
    isHoveringOverMessage(message) {
      return message.nick && message.nick.toLowerCase() === this.hover_nick.toLowerCase();
    },
    toggleMessageInfo(message) {
      if (!message) {
        this.message_info_open = null;
      } else if (this.message_info_open === message) {
        // It's already open, so don't do anything
      } else if (this.canShowInfoForMessage(message)) {
        // If in the process of selecting text, don't show the info box
        let sel = window.getSelection();
        if (sel.rangeCount > 0) {
          let range = sel.getRangeAt(0);
          if (range && !range.collapsed) {
            return;
          }
        }
        this.message_info_open = message;
        this.$nextTick(() => this.maybeScrollToId(message.id));
      }
    },
    // Reveal the message-info bar on hover (desktop only, opt-in). Touch keeps
    // its tap behaviour. Off unless buffers.show_message_info_on_hover is set,
    // so other themes / the default config are unaffected.
    onMessageHover(message, isEntering) {
      if (this.$state.ui.is_touch || !this.showMessageInfoOnHover) {
        return;
      }
      clearTimeout(this.hoverTimer);
      if (isEntering) {
        // short debounce: coalesce fast pointer crossings (eg. scrolling with the
        // cursor over the list) so we don't thrash the shared message_info_open —
        // and the full non-virtualized re-render it triggers — on every grazed line
        if (this.canShowInfoForMessage(message)) {
          this.hoverTimer = setTimeout(() => {
            // don't steal an open bar the user is typing in (eg. ASL kickban
            // reason / report popover, rendered inside .kiwi-messageinfo)
            let focused = document.activeElement;
            if (focused && focused.closest('.kiwi-messageinfo')) {
              return;
            }
            this.message_info_open = message;
          }, 60);
        }
      } else if (this.message_info_open === message) {
        // don't close while a control inside the bar holds focus (keyboard use)
        let focused = document.activeElement;
        if (focused && focused.closest('.kiwi-messageinfo')) {
          return;
        }
        this.message_info_open = null;
      }
    },
    shouldShowUnreadMarker(message) {
      let idx = this.filteredMessages.indexOf(message);
      let previous = this.filteredMessages[idx - 1];
      let current = this.filteredMessages[idx];
      let lastRead = this.buffer.last_read;
      if (!lastRead) {
        return false;
      }
      if (!current) {
        return false;
      }

      // A traffic group spans the time range of its events; compare on the latest one so
      // an unread boundary buried inside a run still surfaces the marker before the group
      // (and, used for previous too, doesn't then duplicate it on the next message).
      let prevTime = previous && this.latestTime(previous);
      let currentTime = this.latestTime(current);

      // If the last message has been read, and this message not read
      if (previous && prevTime < lastRead && currentTime > lastRead) {
        return true;
      }
      return false;
    },
    latestTime(message) {
      return message.is_traffic_group ? message.events[message.events.length - 1].time : message.time;
    },
    shouldShowDateChangeMarker(idx) {
      let previous = this.filteredMessages[idx - 1];
      let current = this.filteredMessages[idx];
      if (!previous && new Date(current.time).getDay() !== new Date().getDay()) {
        // The first message of the lsit and it's not today
        return true;
      } else if (!previous) {
        // The first message of the lsit but it's today
        return false;
      }

      // If the last message has been read, and this message not read
      if (new Date(previous.time).getDay() !== new Date(current.time).getDay()) {
        return true;
      }
      return false;
    },
    canShowInfoForMessage(message) {
      let showInfoForTypes = ['privmsg', 'notice', 'action'];
      if (showInfoForTypes.indexOf(message.type) === -1) {
        return false;
      }
      // our own messages offer no actions (no self-reply, no self-moderation),
      // so the bar would open empty
      if (message.nick && this.ourNick && message.nick.toLowerCase() === this.ourNick.toLowerCase()) {
        return false;
      }
      return true;
    },
    bufferSetting(key) {
      return this.buffer.setting(key);
    },
    formatTime(time) {
      return (0, _strftime.default)(this.buffer.setting('timestamp_format') || '%T', new Date(time));
    },
    formatTimeFull(time) {
      let format = this.buffer.setting('timestamp_full_format');
      return format ? (0, _strftime.default)(format, new Date(time)) : new Date(time).toLocaleString();
    },
    formatMessage(message) {
      return message.toHtml(this);
    },
    isMessageHighlight(message) {
      // Highlighting ourselves when we join or leave a channel is silly
      if (message.type === 'traffic') {
        return false;
      }
      return message.isHighlight;
    },
    userColour(user) {
      if (!this.bufferSetting('colour_nicknames_in_messages')) {
        return '';
      }
      // no live user (e.g. CHATHISTORY from someone who has left): colour the nick like an
      // 'other'-gender user (#000, themed to teal in the dark theme) so it stays coloured
      return user ? user.getColour() : '#000';
    },
    openUserBox(nick) {
      let user = this.$state.getUser(this.buffer.networkid, nick);
      if (user) {
        this.$state.$emit('userbox.show', user, {
          buffer: this.buffer
        });
      }
    },
    onListClick(event) {
      this.toggleMessageInfo();
    },
    onMessageDblClick(event, message) {
      clearTimeout(this.messageClickTmr);
      let dataNick = event.target.getAttribute('data-nick');
      if (!dataNick) {
        return;
      }
      let network = this.buffer.getNetwork();
      let user = network.userByName(dataNick);
      // The user might have left use dataNick as fallback
      let nick = user && user.nick ? user.nick : dataNick;
      this.$state.$emit('input.insertnick', nick);
    },
    onMessageClick(event, message, delay) {
      // Delaying the click for 200ms allows us to check for a second click. ie. double click
      // Quick hack as we only need double click for nicks, nothing else
      if (delay && event.target.getAttribute('data-nick')) {
        clearTimeout(this.messageClickTmr);
        this.messageClickTmr = setTimeout(this.onMessageClick, 200, event, message, false);
        return;
      }
      let isLink = event.target.tagName === 'A';
      let channelName = event.target.getAttribute('data-channel-name');
      if (channelName && isLink) {
        let network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
        this.$state.setActiveBuffer(this.buffer.networkid, channelName);
        return;
      }
      let userNick = event.target.getAttribute('data-nick');
      if (userNick && isLink) {
        this.openUserBox(userNick);
        return;
      }
      let url = event.target.getAttribute('data-url');
      if (url && isLink) {
        if (this.$state.setting('buffers.inline_link_auto_previews')) {
          message.embed.type = 'url';
          message.embed.payload = url;
        } else {
          this.$state.$emit('mediaviewer.show', url);
        }
        return;
      }
      let avatarElement = event.target.closest('.kiwi-avatar');
      if (avatarElement && avatarElement.dataset.nick) {
        this.openUserBox(avatarElement.dataset.nick);
        return;
      }
      if (this.message_info_open && this.message_info_open !== message) {
        // Clicking on another message while another info is open, just close the info
        this.toggleMessageInfo();
        event.preventDefault();
        return;
      }
      if (this.$state.ui.is_touch && this.$state.setting('buffers.show_message_info')) {
        // links navigate and the preview handle (fa-share-square) previews on their
        // own — don't open the action bar over them; tapping the body opens it.
        if (event.target.closest('a')) {
          return;
        }
        this.toggleMessageInfo(message);
      }
    },
    checkScrollingState() {
      let el = this.$el;
      let scrolledUpByPx = el.scrollHeight - (el.offsetHeight + el.scrollTop);

      // We need to know at this point (before the DOM has updated with new messages) if we
      // are at the bottom of the messagelist or not, otherwise once the DOM has updated then
      // it is too late to determine if we should auto scroll down
      if (scrolledUpByPx > BOTTOM_SCROLL_MARGIN) {
        this.auto_scroll = false;
        this.buffer.isMessageTrimming = false;
      } else {
        this.auto_scroll = true;
        this.buffer.isMessageTrimming = true;
      }
      if (this.force_smooth_scroll !== null) {
        this.smooth_scroll = this.force_smooth_scroll;
        this.force_smooth_scroll = null;
        // TODO: Enabling smooth_scroll breaks the auto-scroll-to-bottom on fast buffers as
        //       it takes time to scroll down and it looks like we're scrolled too far up when
        //       detecting if were scrolled up or not. Look into ways around this so that we
        //       can enable it as it does look a lot better.
        // } else if (scrolledUpByPx < BOTTOM_SCROLL_MARGIN) {
        //    this.smooth_scroll = true;
      } else {
        this.smooth_scroll = false;
      }
    },
    onListResize(e) {
      // The messagelist or interface has resized or had new content added
      // check if we should auto scroll down to the bottom
      this.maybeScrollToBottom();
    },
    scrollToBottom() {
      this.$el.scrollTop = this.$el.scrollHeight;
    },
    maybeScrollToBottom() {
      if (this.auto_scroll) {
        this.scrollToBottom();
      }
    },
    maybeScrollToId(id, position = 'middle') {
      let msgEl = this.$el.querySelector('.kiwi-messagelist-message[data-message-id="' + id + '"]');
      if (!msgEl) {
        return;
      }
      let newTop = 0;
      if (position === 'top') {
        // There maybe a sticky unread marker at the top
        newTop = msgEl.offsetTop;
      } else if (position === 'bottom') {
        newTop = Math.floor(msgEl.offsetTop - this.$refs.scroller.offsetHeight + msgEl.offsetHeight);
      } else {
        newTop = Math.floor(msgEl.offsetTop - (this.$refs.scroller.offsetHeight - msgEl.offsetHeight) / 2);
      }
      this.auto_scroll = false;
      this.$refs.scroller.scrollTo({
        top: newTop,
        behavior: 'smooth'
      });
    },
    getSelectedMessages() {
      let sel = document.getSelection();
      if (!sel || sel.rangeCount === 0) {
        return [];
      }

      // Firefox allows several ranges in one selection, chromium only ever has one
      let ranges = [];
      for (let i = 0; i < sel.rangeCount; i++) {
        ranges.push(sel.getRangeAt(i));
      }
      let messageEls = [...this.$el.querySelectorAll('.kiwi-messagelist-message')];
      return messageEls.filter(el => ranges.some(r => r.intersectsNode(el)));
    },
    // True when every end of the selection sits inside the message body, ie. the user is
    // picking text out of a message rather than taking the message as a whole. The modern
    // layout puts the nick and time on their own line above the body, so a selection
    // covering them has to be treated as taking the whole message, not as partial text.
    isSelectionWithinBody(messageEl) {
      let sel = document.getSelection();
      if (!sel || sel.rangeCount === 0) {
        return false;
      }
      let inBody = node => {
        if (!node) {
          return false;
        }
        let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        return !!el && messageEl.contains(el) && !!el.closest('.kiwi-messagelist-body');
      };
      for (let i = 0; i < sel.rangeCount; i++) {
        let r = sel.getRangeAt(i);
        if (!inBody(r.startContainer) || !inBody(r.endContainer)) {
          return false;
        }
      }
      return true;
    },
    // The messages the current selection should copy as a whole. An empty list means
    // "let the browser copy the text it selected".
    messagesForCopy() {
      let selection = document.getSelection();
      if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
        return [];
      }
      if (!this.$el || !this.$el.contains(selection.anchorNode)) {
        // Selected elsewhere on the page
        return [];
      }
      let messageIds = this.buffer.messagesObj.messageIds;
      let messageEls = this.getSelectedMessages().filter(el => !!messageIds[el.dataset.messageId]);
      if (messageEls.length === 0) {
        return [];
      }

      // Copying part of a single message, keep the browsers verbatim text
      if (messageEls.length === 1 && this.isSelectionWithinBody(messageEls[0])) {
        return [];
      }
      return messageEls.map(el => messageIds[el.dataset.messageId]);
    },
    removeSelections(removeNative = false) {
      this.selectedMessages = Object.create(null);
      let selection = document.getSelection();
      if (removeNative && selection) {
        // stops the native browser selection being left behind after ctrl+c
        selection.removeAllRanges();
      }
    },
    addCopyListeners() {
      // Better copy pasting
      let selecting = false;
      let selectionChangeOff = null;
      let onSelectionChange = () => {
        if (!this.$el) {
          return;
        }
        selecting = true;

        // Mark the messages that will be copied as a whole. Replacing the object
        // re-renders every message, so leave it alone while the set is unchanged
        let selected = this.messagesForCopy();
        let current = Object.keys(this.selectedMessages);
        if (selected.length === current.length && selected.every(m => this.selectedMessages[m.id])) {
          return;
        }
        let selectedMessages = Object.create(null);
        selected.forEach(m => {
          selectedMessages[m.id] = m;
        });
        this.selectedMessages = selectedMessages;
      };
      this.listen(document, 'selectstart', e => {
        this.removeSelections();
        selectionChangeOff && selectionChangeOff();
        selectionChangeOff = null;
        if (!this.$el.contains(e.target)) {
          // Selected elsewhere on the page
          return;
        }
        selectionChangeOff = this.listen(document, 'selectionchange', onSelectionChange);
      });
      this.listen(document, 'mouseup', e => {
        selectionChangeOff && selectionChangeOff();
        selectionChangeOff = null;
        if (selecting) {
          e.preventDefault();
        }
        selecting = false;
      });
      this.listen(document, 'copy', e => {
        // Built from the live selection rather than from what the selectionchange
        // handler last saw, so a selection made without us seeing a selectstart
        // (keyboard selection) is formatted too
        let copyData = (0, _MessageCopyFormat.buildCopyText)(this.messagesForCopy());
        if (!copyData) {
          // Just do a normal copy if no special data
          return true;
        }
        e.preventDefault();
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', copyData);
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(copyData);
        } else {
          let input = document.createElement('textarea');
          document.body.appendChild(input);
          input.value = copyData;
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
        }
        return true;
      });
    },
    // Move a messages embeded content to the main media preview
    openEmbedInPreview(message) {
      // First open the embed in the main media preview
      let embed = message.embed;
      if (embed.type === 'url') {
        this.$state.$emit('mediaviewer.show', embed.payload);
      } else if (embed.type === 'component') {
        this.$state.$emit('mediaviewer.show', {
          component: embed.payload
        });
      }

      // Remove the embed from the message
      embed.payload = null;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageList"]
window._kiwi_exports.components.MessageList = exports.default ? exports.default : exports;
